import { render, staticRenderFns } from "./DemandeReinscriptionPsychotherapeute.vue?vue&type=template&id=fc715120"
import script from "./DemandeReinscriptionPsychotherapeute.vue?vue&type=script&lang=js"
export * from "./DemandeReinscriptionPsychotherapeute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports